import { render, staticRenderFns } from "./ProductDetailCard.vue?vue&type=template&id=237bb0f2&scoped=true&"
import script from "./ProductDetailCard.vue?vue&type=script&lang=js&"
export * from "./ProductDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailCard.vue?vue&type=style&index=0&id=237bb0f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237bb0f2",
  null
  
)

export default component.exports